import { ENVIRONMENTS } from './app.constants';
/**
 * TODO: [Angular 7] This process should be environment variables
 */
import { environment } from '../environments/environment';

const process = {
  env: {} as any,
};

const environments = {
  [ENVIRONMENTS.DEVELOPMENT]: {
    digitId: 'd',
    BASE_URL: 'http://localhost:5000',
    api: process.env.API_URL || 'https://homebroker-api.stg-gbm.com/GBMP/',
    user_preferences_api:
      process.env.USER_PREFERENCES_API_URL ||
      'https://api.user-preferences.stg-gbm.com/v1',
    app: process.env.APP_ID || '16',
    solace_code: process.env.SOLACE_CODE || 'dn3h9VlfZdSE52v', // UATE: WEB_SL
    solace_connectRetryCount: process.env.SOLACE_CONNECT_RETRY_COUNT || '10',
    solace_endPoint:
      process.env.SOLACE_ENDPOINT || 'https://msg.market.stg-gbmapi.com/smf',
    solace_subscriptionRetryCount:
      process.env.SOLACE_SUBSCRIBE_RETRY_COUNT || '5',
    solace_subscriptionRetryInterval:
      process.env.SOLACE_SUBSCRIBE_RETRY_INTERVAL || '5000',
    solace_subscriptionTimeout: process.env.SOLACE_SUBSCRIBE_TIMEOUT || '10000',
    solace_topicSplitter: process.env.SOLACE_TOPIC_SPLITTER || '/',
    solace_userName: process.env.SOLACE_USERNAME || 'WEB_SL',
    solace_password: process.env.SOLACE_PASSWORD || 'WEB_SL',
    solace_vpnName: process.env.SOLACE_VPN_NAME || 'GBM_HBPRO_PROD', // UATE: GBM_HBPRO_UAT
    timeOuts_timeOut1Min: '60000',
    timeOuts_timeOut2Min: '120000',
    timeOuts_timeOut5Min: '300000',
    timeOuts_timeOut10Min: '600000',
    timeOuts_timeOut30Seg: '30000',
    t_report_tokenDomain: 'GBM',
    t_report_url:
      'http://gbm.techrules.com/SOA/Treport.V1/TReport/index/es-MX/GBM?StockId=',
    new_t_report_url:
      'https://gbm.techrules.com/SOA20/TReport/Index?BusinessArea=GBM&Language=es-MX&StockId=',
    comparador_url:
      'https://gbm.techrules.com/SOA/Comparator/ComparatorIndex.aspx?businessArea=GBM&assets=',
    t_report_key: 'ksudjGTR564yTTDR',
    t_report_token: 'RfTzjgdINWxKQhpTxvqu/Ocj3zCpM4U0',
    EL_PATRON: {
      URL_BASE: 'https://origin.auth.stg-gbm.com',
      URL_SIGNIN:
        process.env.ELPATRON_URL_SIGNIN ||
        'https://origin.auth.stg-gbm.com/signin?client_id=af4d6859594d43518c776c1538b249a9',
      URL_SIGNOUT:
        process.env.ELPATRON_URL_SIGNOUT ||
        'https://origin.auth.stg-gbm.com/signout?client_id=af4d6859594d43518c776c1538b249a9',
      URL_MFA:
        process.env.ELPATRON_URL_MFA ||
        'https://origin.auth.stg-gbm.com/api/v1/security-settings',
      URL_SETTINGS:
        process.env.ELPATRON_URL_SETTINGS ||
        'https://origin.auth.stg-gbm.com/settings?client_id=af4d6859594d43518c776c1538b249a9',
      URL_SET_MFA:
        process.env.ELPATRON_URL_SET_MFA ||
        'https://origin.auth.stg-gbm.com/settings/mfa?client_id=af4d6859594d43518c776c1538b249a9',
      URL_CHALLENGE:
        process.env.ELPATRON_URL_CHALLENGE ||
        'https://origin.auth.stg-gbm.com/api/v1/challenge',
      URL_REFRESH:
        process.env.ELPATRON_URL_REFRESH ||
        'https://origin.auth.stg-gbm.com/api/v1/session/user/refresh',
      CLIENT_ID:
        process.env.ELPATRON_CLIENT_ID || 'af4d6859594d43518c776c1538b249a9',
      URL_TOKEN_INFO:
        process.env.ELPATRON_TOKEN_INFO ||
        'https://origin.auth.stg-gbm.com/api/v1/token-info',
      URL_UPGRADE_SESSION:
        process.env.ELPATRON_UPGRADE_SESSION ||
        'https://origin.auth.stg-gbm.com/api/v1/token',
      GET_PARTY_URL:
        process.env.GET_PARTY_URL || 'https://origin.account.stg-gbmapi.com/',
      SILENT_URL:
        process.env.SILENT_URL ||
        'https://origin.auth.stg-gbm.com/signin?client_id=af4d6859594d43518c776c1538b249a9&silent=true',
      GBMCOM_DASHBOARD:
        process.env.GBMCOM_DASHBOARD ||
        'https://origin.app.stg-gbm.com/dashboard',
    },
    DOTCOM: {
      BASE_URL:
        process.env.GBMCOM_DASHBOARD || 'https://origin.app.stg-gbm.com',
      BANK_ACCOUNT:
        (process.env.GBMCOM_DASHBOARD || 'https://origin.app.stg-gbm.com') +
        '/bank-account',
      BLACK_UPGRADE:
        (process.env.GBMCOM_DASHBOARD || 'https://origin.app.stg-gbm.com') +
        '/contract-opening-black-upgrade',
    },
    analytics: {
      mixpanelApiKey: '8ff89039b721db846de3ae187166d05a',
    },
    FEATURE_MANAGER_API_KEY: '473a46dc-686f-4b81-909e-d4f8e17342ae',
    GBM_COM_API: process.env.GBM_COM_API || 'https://origin.api.stg-gbm.com/',
    LOREM_API: 'https://origin.account.stg-gbmapi.com/',
    PRICE_ALERTS_API: 'https://api.alerts.stg-gbm.com/',
    TRADING_USA_API: 'https://api.trading-usa.stg-gbm.com/',
    NEWS_API: 'https://api.news-service.dev-gbm.com/',
    UJET_AUTH_URL: 'https://api.gbm.com/v1/ujet-token',
  },
  [ENVIRONMENTS.STAGE]: {
    digitId: 'd',
    BASE_URL: 'https://homebroker.stg-gbm.com',
    api: process.env.API_URL || 'https://homebroker-api.stg-gbm.com/GBMP/',
    user_preferences_api:
      process.env.USER_PREFERENCES_API_URL ||
      'https://api.user-preferences.stg-gbm.com/v1',
    app: process.env.APP_ID || '16',
    solace_code: process.env.SOLACE_CODE || 'dn3h9VlfZdSE52v', // UATE: WEB_SL
    solace_connectRetryCount: process.env.SOLACE_CONNECT_RETRY_COUNT || '10',
    solace_endPoint:
      process.env.SOLACE_ENDPOINT || 'https://msg.market.stg-gbmapi.com/smf',
    solace_subscriptionRetryCount:
      process.env.SOLACE_SUBSCRIBE_RETRY_COUNT || '5',
    solace_subscriptionRetryInterval:
      process.env.SOLACE_SUBSCRIBE_RETRY_INTERVAL || '5000',
    solace_subscriptionTimeout: process.env.SOLACE_SUBSCRIBE_TIMEOUT || '10000',
    solace_topicSplitter: process.env.SOLACE_TOPIC_SPLITTER || '/',
    solace_userName: process.env.SOLACE_USERNAME || 'WEB_SL',
    solace_password: process.env.SOLACE_PASSWORD || 'WEB_SL',
    solace_vpnName: process.env.SOLACE_VPN_NAME || 'GBM_HBPRO_PROD', // UATE: GBM_HBPRO_UAT
    timeOuts_timeOut1Min: '60000',
    timeOuts_timeOut2Min: '120000',
    timeOuts_timeOut5Min: '300000',
    timeOuts_timeOut10Min: '600000',
    timeOuts_timeOut30Seg: '30000',
    t_report_tokenDomain: 'GBM',
    t_report_url:
      'http://gbm.techrules.com/SOA/Treport.V1/TReport/index/es-MX/GBM?StockId=',
    new_t_report_url:
      'https://gbm.techrules.com/SOA20/TReport/Index?BusinessArea=GBM&Language=es-MX&StockId=',
    comparador_url:
      'https://gbm.techrules.com/SOA/Comparator/ComparatorIndex.aspx?businessArea=GBM&assets=',
    t_report_key: 'ksudjGTR564yTTDR',
    t_report_token: 'RfTzjgdINWxKQhpTxvqu/Ocj3zCpM4U0',
    EL_PATRON: {
      URL_BASE: 'https://origin.auth.stg-gbm.com',
      URL_SIGNIN:
        process.env.ELPATRON_URL_SIGNIN ||
        'https://origin.auth.stg-gbm.com/signin?client_id=d8fb00c17bb94f19953756af1ccf4e69',
      URL_SIGNOUT:
        process.env.ELPATRON_URL_SIGNOUT ||
        'https://origin.auth.stg-gbm.com/signout?client_id=d8fb00c17bb94f19953756af1ccf4e69',
      URL_MFA:
        process.env.ELPATRON_URL_MFA ||
        'https://origin.auth.stg-gbm.com/api/v1/security-settings',
      URL_SETTINGS:
        process.env.ELPATRON_URL_SETTINGS ||
        'https://origin.auth.stg-gbm.com/settings?client_id=d8fb00c17bb94f19953756af1ccf4e69',
      URL_SET_MFA:
        process.env.ELPATRON_URL_SET_MFA ||
        'https://origin.auth.stg-gbm.com/settings/mfa?client_id=d8fb00c17bb94f19953756af1ccf4e69',
      URL_CHALLENGE:
        process.env.ELPATRON_URL_CHALLENGE ||
        'https://origin.auth.stg-gbm.com/api/v1/challenge',
      URL_REFRESH:
        process.env.ELPATRON_URL_REFRESH ||
        'https://origin.auth.stg-gbm.com/api/v1/session/user/refresh',
      CLIENT_ID:
        process.env.ELPATRON_CLIENT_ID || 'd8fb00c17bb94f19953756af1ccf4e69',
      URL_TOKEN_INFO:
        process.env.ELPATRON_TOKEN_INFO ||
        'https://origin.auth.stg-gbm.com/api/v1/token-info',
      URL_UPGRADE_SESSION:
        process.env.ELPATRON_UPGRADE_SESSION ||
        'https://origin.auth.stg-gbm.com/api/v1/token',
      GET_PARTY_URL:
        process.env.GET_PARTY_URL || 'https://origin.account.stg-gbmapi.com/',
      SILENT_URL:
        process.env.SILENT_URL ||
        'https://origin.auth.stg-gbm.com/signin?client_id=d8fb00c17bb94f19953756af1ccf4e69&silent=true',
      GBMCOM_DASHBOARD:
        process.env.GBMCOM_DASHBOARD ||
        'https://origin.app.stg-gbm.com/dashboard',
    },
    DOTCOM: {
      BASE_URL:
        process.env.GBMCOM_DASHBOARD || 'https://origin.app.stg-gbm.com',
      BANK_ACCOUNT:
        (process.env.GBMCOM_DASHBOARD || 'https://origin.app.stg-gbm.com') +
        '/bank-account',
      BLACK_UPGRADE:
        (process.env.GBMCOM_DASHBOARD || 'https://origin.app.stg-gbm.com') +
        '/contract-opening-black-upgrade',
    },
    analytics: {
      mixpanelApiKey: '8ff89039b721db846de3ae187166d05a',
    },
    FEATURE_MANAGER_API_KEY: 'be31cf87-4aaf-4e3d-97b4-38f40376d3d0',
    GBM_COM_API: process.env.GBM_COM_API || 'https://origin.api.stg-gbm.com/',
    LOREM_API: 'https://origin.account.stg-gbmapi.com/',
    PRICE_ALERTS_API: 'https://api.alerts.stg-gbm.com/',
    TRADING_USA_API: 'https://api.trading-usa.stg-gbm.com/',
    NEWS_API: 'https://api.news-service.stg-gbm.com/',
    UJET_AUTH_URL: 'https://api.gbm.com/v1/ujet-token',
  },
  [ENVIRONMENTS.PRODUCTION]: {
    digitId: 'p',
    BASE_URL: 'https://homebroker.gbm.com',
    api: process.env.API_URL || 'https://homebroker-api.gbm.com/GBMP/',
    user_preferences_api:
      process.env.USER_PREFERENCES_API_URL ||
      'https://api.user-preferences.gbm.com/v1',
    app: process.env.APP_ID || '16',
    solace_code: process.env.SOLACE_CODE || 'dn3h9VlfZdSE52v',
    solace_connectRetryCount: process.env.SOLACE_CONNECT_RETRY_COUNT || '10',
    solace_endPoint:
      process.env.SOLACE_ENDPOINT || 'https://msg.market.gbmapi.com/smf',
    solace_subscriptionRetryCount:
      process.env.SOLACE_SUBSCRIBE_RETRY_COUNT || '5',
    solace_subscriptionRetryInterval:
      process.env.SOLACE_SUBSCRIBE_RETRY_INTERVAL || '5000',
    solace_subscriptionTimeout: process.env.SOLACE_SUBSCRIBE_TIMEOUT || '10000',
    solace_topicSplitter: process.env.SOLACE_TOPIC_SPLITTER || '/',
    solace_userName: process.env.SOLACE_USERNAME || 'WEB_SL',
    solace_password: process.env.SOLACE_PASSWORD || 'WEB_SL',
    solace_vpnName: process.env.SOLACE_VPN_NAME || 'GBM_HBPRO_PROD',
    timeOuts_timeOut1Min: '60000',
    timeOuts_timeOut2Min: '120000',
    timeOuts_timeOut5Min: '300000',
    timeOuts_timeOut10Min: '600000',
    timeOuts_timeOut30Seg: '30000',
    t_report_tokenDomain: 'GBM',
    t_report_url:
      'http://gbm.techrules.com/SOA/Treport.V1/TReport/index/es-MX/GBM?StockId=',
    new_t_report_url:
      'https://gbm.techrules.com/SOA20/TReport/Index?BusinessArea=GBM&Language=es-MX&StockId=',
    comparador_url:
      'https://gbm.techrules.com/SOA/Comparator/ComparatorIndex.aspx?businessArea=GBM&assets=',
    t_report_key: 'ksudjGTR564yTTDR',
    t_report_token: 'RfTzjgdINWxKQhpTxvqu/Ocj3zCpM4U0',
    EL_PATRON: {
      URL_BASE: 'https://auth.gbm.com',
      URL_SIGNIN:
        process.env.ELPATRON_URL_SIGNIN ||
        'https://auth.gbm.com/signin?client_id=7c464570619a417080b300076e163289',
      URL_SIGNOUT:
        process.env.ELPATRON_URL_SIGNOUT ||
        'https://auth.gbm.com/signout?client_id=7c464570619a417080b300076e163289',
      URL_MFA:
        process.env.ELPATRON_URL_MFA ||
        'https://auth.gbm.com/api/v1/security-settings',
      URL_SETTINGS:
        process.env.ELPATRON_URL_SETTINGS ||
        'https://auth.gbm.com/settings?client_id=7c464570619a417080b300076e163289',
      URL_SET_MFA:
        process.env.ELPATRON_URL_SET_MFA ||
        'https://auth.gbm.com/settings/mfa?client_id=7c464570619a417080b300076e163289',
      URL_CHALLENGE:
        process.env.ELPATRON_URL_CHALLENGE ||
        'https://auth.gbm.com/api/v1/challenge',
      URL_REFRESH:
        process.env.ELPATRON_URL_REFRESH ||
        'https://auth.gbm.com/api/v1/session/user/refresh',
      CLIENT_ID:
        process.env.ELPATRON_CLIENT_ID || '7c464570619a417080b300076e163289',
      URL_TOKEN_INFO:
        process.env.ELPATRON_TOKEN_INFO ||
        'https://auth.gbm.com/api/v1/token-info',
      URL_UPGRADE_SESSION:
        process.env.ELPATRON_UPGRADE_SESSION ||
        'https://auth.gbm.com/api/v1/token',
      GET_PARTY_URL: process.env.GET_PARTY_URL || 'https://account.gbmapi.com/',
      SILENT_URL:
        process.env.SILENT_URL ||
        'https://auth.gbm.com/signin?client_id=7c464570619a417080b300076e163289&silent=true',
      GBMCOM_DASHBOARD:
        process.env.GBMCOM_DASHBOARD || 'https://app.gbm.com/dashboard',
    },
    DOTCOM: {
      BASE_URL: process.env.GBMCOM_DASHBOARD || 'https://app.gbm.com',
      BANK_ACCOUNT:
        (process.env.GBMCOM_DASHBOARD || 'https://app.gbm.com') +
        '/bank-account',
      BLACK_UPGRADE:
        (process.env.GBMCOM_DASHBOARD || 'https://app.gbm.com') +
        '/contract-opening-black-upgrade',
    },
    analytics: {
      mixpanelApiKey: '3457f824a8dadfb4e99311b8ec7d87ce',
    },
    FEATURE_MANAGER_API_KEY: '19767613-4526-4dd1-9702-9a1d5cf5bd3e',
    GBM_COM_API: process.env.GBM_COM_API || 'https://api.gbm.com/',
    LOREM_API: 'https://account.gbmapi.com/',
    PRICE_ALERTS_API: 'https://api.alerts.gbm.com/',
    TRADING_USA_API: 'https://api.trading-usa.gbm.com/',
    NEWS_API: 'https://api.news.gbm.com/',
    UJET_AUTH_URL: 'https://api.gbm.com/v1/ujet-token',
  },
};

const getEnv = (appEnv: string) => {
  let environmentShadowed = appEnv || ENVIRONMENTS.DEVELOPMENT;
  if (Object.keys(environments).indexOf(environmentShadowed) < 0) {
    environmentShadowed = ENVIRONMENTS.DEVELOPMENT;
  }
  return environmentShadowed;
};

export const config = () => {
  const NODE_ENV = getEnv(
    environment.appConfigurationEnvironment || process.env.NODE_ENV,
  );
  const env = {
    NODE_ENV,
    ...environments[NODE_ENV],
  };

  return env;
};
